import {
  Box,
  Button,
  Center,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  HStack,
  Input,
  Radio,
  RadioGroup,
  Select,
  SimpleGrid,
  Stack,
  Text,
  Textarea,
} from '@chakra-ui/react'
import { DatePicker } from 'antd'
import moment from 'moment'
import React, { useState } from 'react'
import { Controller } from 'react-hook-form'
import Signature from '../../../Components/Signature'
import { modals } from '../../../Components/Modal'
import { CloseIcon } from '@chakra-ui/icons'

export default function MDList({
  errors,
  register,
  control,
  questionMD,
  setValue,
  data,
  watch,
  trigger,
  remove,
  index,
  isCreate,
  reviewerOptions,
}) {
  const [isConfirm, setIsConfirm] = useState(false)
  const onRemove = () => setIsConfirm(true)
  return (
    <>
      {modals.confirm({
        isOpen: isConfirm,
        onClose: () => setIsConfirm(false),
        onSubmit: () => {
          setIsConfirm(false)
          remove(index)
        },
      })}
      {index !== 0 && (
        <hr
          style={{
            backgroundColor: 'black',
            height: 1,
            margin: '16px 0px',
          }}
        />
      )}
      <Box>
        <Center>
          <FormControl
            id="performed"
            style={{
              width: '20%',
              marginBottom: '12px',
            }}
          >
            <FormLabel>Performed by provider</FormLabel>
            <Input
              name={`form.performed`}
              defaultValue={data?.performed || '0'}
              ref={register()}
            />
          </FormControl>
        </Center>
        <HStack>
          <FormControl
            id="anesthesia"
            isRequired
            isInvalid={errors?.form?.list?.[index]?.anesthesia}
          >
            <FormLabel>Surgeon</FormLabel>
            <Input
              name={`form.list.${index}.anesthesia`}
              placeholder="Surgeon"
              ref={register({
                required: 'Surgeon required.',
              })}
              defaultValue={data?.list?.[index]?.anesthesia || ''}
            />
          </FormControl>
          <FormControl
            id="period"
            isRequired
            isInvalid={errors?.form?.list?.[index]?.period}
          >
            <FormLabel>Period</FormLabel>

            <Controller
              render={props => (
                <DatePicker
                  style={{
                    width: '100%',
                    height: '100%',
                  }}
                  value={props?.value}
                  picker="quarter"
                  onChange={props.onChange}
                  format={'Y-[Q]Q'}
                />
              )}
              name={`form.list.${index}.period`}
              control={control}
              rules={{ required: 'Period required.' }}
              defaultValue={
                data?.list?.[index]?.period
                  ? moment(data?.list?.[index]?.period)
                  : moment()
              }
            />
            <FormErrorMessage>
              {errors?.form?.list?.[index]?.period &&
                errors?.form?.list?.[index]?.period?.message}
            </FormErrorMessage>
          </FormControl>
          <FormControl
            id="mr"
            isRequired
            isInvalid={errors?.form?.list?.[index]?.mr}
          >
            <FormLabel>MR#</FormLabel>
            <Input
              name={`form.list.${index}.mr`}
              placeholder="MR#"
              ref={register({
                required: 'MR# required.',
              })}
              defaultValue={data?.list?.[index]?.mr || ''}
            />
          </FormControl>
          <FormControl isRequired isInvalid={errors?.form?.list?.[index]?.dos}>
            <FormLabel>DOS</FormLabel>
            <Controller
              render={props => (
                <DatePicker
                  style={{
                    width: '100%',
                    height: '100%',
                  }}
                  value={props?.value}
                  onChange={props?.onChange}
                />
              )}
              name={`form.list.${index}.dos`}
              control={control}
              rules={{ required: 'DOS is required.' }}
              defaultValue={
                data?.list?.[index]?.dos
                  ? moment(data?.list?.[index]?.dos)
                  : moment()
              }
            />
          </FormControl>
        </HStack>
      </Box>
      <Text fontSize="xl" fontWeight="bold" my={6}>
        SURGEON PEER/UTILIZATION REVIEW CRITERIA
      </Text>
      <Box>
        {questionMD.map((item, qIndex) => (
          <Flex key={qIndex} justifyContent="space-between" my={4}>
            <Text fontSize={18}>
              {qIndex + 1}. {item}
            </Text>
            <Flex gap={8}>
              <FormControl
                isInvalid={
                  errors?.form?.list?.[index]?.answers &&
                  errors?.form?.list?.[index]?.answers[qIndex]
                }
              >
                <Controller
                  render={props => (
                    <RadioGroup
                      onChange={props.onChange}
                      value={props.value}
                      pr={qIndex === 7 || qIndex === 8 ? 0 : '61px'}
                    >
                      <Stack direction="row">
                        <Radio value="yes">Yes</Radio>
                        <Radio value="no">No</Radio>
                        {(qIndex === 7 || qIndex === 8) && (
                          <Radio value="n/a">N/A</Radio>
                        )}
                      </Stack>
                    </RadioGroup>
                  )}
                  name={`form.list.${index}.answers.${qIndex}`}
                  control={control}
                  rules={{ required: isCreate }}
                  defaultValue={data?.list?.[index]?.answers?.[qIndex] || ''}
                />
              </FormControl>
            </Flex>
          </Flex>
        ))}
      </Box>
      <Box mt={12}>
        <FormControl>
          <Text mb="8px">Comment: </Text>
          <Controller
            render={props => (
              <Textarea
                value={props.value}
                placeholder="Comment"
                onChange={props.onChange}
              />
            )}
            name={`form.list.${index}.comment`}
            control={control}
            defaultValue={data?.list?.[index]?.comment || ''}
          />
        </FormControl>
      </Box>

      <SimpleGrid columns={2} spacingX="40px" spacingY="20px">
        <Box>
          <Controller
            name={`form.list.${index}.signatureCollector`}
            control={control}
            rules={{
              required: { value: isCreate, message: 'Signature is required.' },
            }}
            defaultValue={''}
            render={({ field }) => {
              return (
                <FormControl
                  w="30vw"
                  isInvalid={errors?.form?.list?.[index]?.signatureCollector}
                >
                  <Signature
                    label="Peer Reviewer Signature"
                    field={field}
                    setValue={setValue}
                    watch={watch}
                    data={data?.list?.[index]?.signatureCollector}
                    trigger={trigger}
                    formKey={`form.list.${index}.signatureCollector`}
                    isRequired={errors?.form?.list?.[index]?.signatureCollector}
                  />
                  <FormErrorMessage>
                    {errors?.form?.list?.[index]?.signatureCollector &&
                      errors?.form?.list?.[index]?.signatureCollector.message}
                  </FormErrorMessage>
                </FormControl>
              )
            }}
          />
        </Box>
        <Box display={'flex'} alignItems={'end'}>
          <FormControl isRequired={isCreate}>
            <FormLabel>Date</FormLabel>
            <Controller
              render={props => (
                <Input
                  value={props.value}
                  onChange={props.onChange}
                  isReadOnly
                  textAlign={'center'}
                />
              )}
              name={`form.list.${index}.date`}
              control={control}
              defaultValue={
                isCreate
                  ? moment().format('YYYY-MM-DD')
                  : data?.list?.[index]?.date || ''
              }
              rules={{
                required: { value: isCreate, message: 'Date is required.' },
              }}
            />
          </FormControl>
        </Box>
        <Box>
          <FormControl id="reviewer">
            <FormLabel>Peer Reviewer Printed Name:</FormLabel>
            <Select
              name={`form.list.${index}.reviewer`}
              placeholder="Peer Reviewer Printed Name"
              ref={register()}
              defaultValue={data?.list?.[index]?.reviewer || ''}
            >
              {reviewerOptions?.map(item => (
                <option key={item.id} value={item.fullName}>
                  {item.fullName}
                </option>
              ))}
            </Select>
          </FormControl>
        </Box>
      </SimpleGrid>
      <Button
        mt={8}
        mb={4}
        variant="outline"
        leftIcon={<CloseIcon />}
        onClick={() => onRemove()}
        colorScheme="red"
      >
        Remove
      </Button>
    </>
  )
}
